import { render, staticRenderFns } from "./SyncDeletedTable.vue?vue&type=template&id=dec9e334"
import script from "./SyncDeletedTable.vue?vue&type=script&lang=ts"
export * from "./SyncDeletedTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports